import React from 'react';
import { ThumbsUp, Banknote } from 'lucide-react';
import { StatSection, type Stat } from './StatSection';

export interface QuickStatsSectionProps {
  stats: Stat[];
}

export const QuickStatsSection: React.FC<QuickStatsSectionProps> = ({ stats }) => {
  const engagementStats = stats.filter((s) =>
    ['Influencers', 'Posts', 'Engagement', 'Views', 'Total Likes', 'Total Comments', 'Total Shares'].includes(
      s.label
    )
  );

  const financialStats = stats.filter((s) =>
    ['CPV', 'CPE', 'Committed', 'Spent', 'Remaining'].includes(s.label)
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Engagement Metrics */}
      <StatSection
        title="Engagement Metrics"
        icon={ThumbsUp}
        stats={engagementStats}
      />
      {/* Financial Analysis */}
      <StatSection
        title="Financial Analysis"
        icon={Banknote}
        stats={financialStats}
      />
    </div>
  );
};

export default QuickStatsSection;
